/**
 * Hybrid breadcrumbs: minimal SSR + LocalStorage stack for visible <ol>.
 *
 * Data: bc_nav = [{ type, handle, name, subcategories? }] — type "collection"|"product"; collection entries include
 * subcategories: handle[] from custom.subcategories. Max 2
 * collection entries; total max 8. bc_ts = last update, TTL 30 min.
 *
 * Collection → collection: verify A→B with B ∈ A.subcategories when non-empty; else A.handle ∈ B’s
 * data-parent-handles. If both empty, tail collections are stripped.
 * Product: LS breadcrumb only if the last stack collection is in product.collections; otherwise drop
 * collection entries (keep SSR) and persist.
 */
(function () {
    var KEY_NAV = 'bc_nav';
    var KEY_TS = 'bc_ts';
    var TTL_SEC = 1800;
    var MAX_ENTRIES = 8;
    var MAX_COLLECTIONS = 2;
    var ENTRY_COLLECTION = 'collection';
    var ENTRY_PRODUCT = 'product';

    function getNav() {
      try {
        var raw = localStorage.getItem(KEY_NAV);
        if (!raw) return [];
        var arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    }
  
    function getTs() {
      try {
        var raw = localStorage.getItem(KEY_TS);
        return raw ? parseInt(raw, 10) : 0;
      } catch (e) {
        return 0;
      }
    }
  
    function setNav(arr) {
      try {
        localStorage.setItem(KEY_NAV, JSON.stringify(arr));
      } catch (e) {}
    }
  
    function setTs(ts) {
      try {
        localStorage.setItem(KEY_TS, String(ts));
      } catch (e) {}
    }
  
    function isExpired() {
      return Math.floor(Date.now() / 1000) - getTs() > TTL_SEC;
    }
  
    function trimToMax(arr) {
      return arr.length > MAX_ENTRIES ? arr.slice(-MAX_ENTRIES) : arr;
    }

    /** Keep only the last maxCols collection entries (by order in stack); products and order otherwise preserved. */
    function keepLastNCollections(stack, maxCols) {
      var colIndices = [];
      for (var i = 0; i < stack.length; i++) {
        if (stack[i].type === ENTRY_COLLECTION) colIndices.push(i);
      }
      if (colIndices.length <= maxCols) return stack.slice();
      var drop = colIndices.length - maxCols;
      var dropIndex = {};
      for (var j = 0; j < drop; j++) {
        dropIndex[colIndices[j]] = true;
      }
      var result = [];
      for (var k = 0; k < stack.length; k++) {
        if (!dropIndex[k]) result.push(stack[k]);
      }
      return result;
    }

    function finalizeNavStack(stack) {
      return trimToMax(keepLastNCollections(stack, MAX_COLLECTIONS));
    }
  
    function isBackForward() {
      try {
        var nav = performance.getEntriesByType && performance.getEntriesByType('navigation');
        return nav && nav[0] && nav[0].type === 'back_forward';
      } catch (e) {
        return false;
      }
    }
  
    function getCollectionsFromStack(stack) {
      return stack.filter(function (e) { return e.type === ENTRY_COLLECTION; });
    }

    /** Pop from the end while the last entry is a product (e.g. product → collection navigation). */
    function removeTrailingProductsFromStack(stack) {
      var s = stack.slice();
      while (s.length > 0 && s[s.length - 1].type === ENTRY_PRODUCT) {
        s.pop();
      }
      return s;
    }

    /** Remove every stack entry for this collection handle (re-add on push so order stays correct). */
    function removeDuplicateCollectionHandles(stack, handle) {
      if (!handle) return stack.slice();
      return stack.filter(function (e) {
        return !(e.type === ENTRY_COLLECTION && e.handle === handle);
      });
    }

    /** Index of the last collection entry in stack (by array order). */
    function indexOfLastCollection(stack) {
      for (var i = stack.length - 1; i >= 0; i--) {
        if (stack[i].type === ENTRY_COLLECTION) return i;
      }
      return -1;
    }

    function normalizeSubs(entry) {
      if (!entry || entry.type !== ENTRY_COLLECTION) return [];
      var subs = entry.subcategories;
      return Array.isArray(subs) ? subs : [];
    }

    /**
     * Last stack collection L accepts navigating to nextHandle (collection B) if:
     * - L.subcategories non-empty and nextHandle is listed there, or
     * - L.subcategories empty and parentHandles (B’s data-parent-handles) contains L.handle.
     */
    function lastColAcceptsStep(lastCol, nextHandle, parentHandles) {
      if (!lastCol || !nextHandle) return false;
      var subs = normalizeSubs(lastCol);
      if (subs.length > 0) {
        return subs.indexOf(nextHandle) !== -1;
      }
      if (parentHandles && parentHandles.length > 0) {
        return parentHandles.indexOf(lastCol.handle) !== -1;
      }
      return false;
    }

    /**
     * Drop trailing collections until the last accepts nextHandle (collection B), or stack has none.
     */
    function stripCollectionsForNextCollection(stack, nextHandle, parentHandles) {
      var s = stack.slice();
      var hasParents = parentHandles && parentHandles.length > 0;
      while (true) {
        var cols = getCollectionsFromStack(s);
        if (cols.length === 0) break;
        var lastCol = cols[cols.length - 1];
        var subs = normalizeSubs(lastCol);
        var accepts = false;
        if (subs.length > 0) {
          accepts = subs.indexOf(nextHandle) !== -1;
        } else if (hasParents) {
          accepts = parentHandles.indexOf(lastCol.handle) !== -1;
        } else {
          accepts = false;
        }
        if (accepts) break;
        var idx = indexOfLastCollection(s);
        if (idx === -1) break;
        s.splice(idx, 1);
      }
      return s;
    }
  
    function homeLabel() {
      var home = document.querySelector('.n6br a[href="/"]');
      return home ? home.textContent.trim() : 'Home';
    }
  
    function buildOlFromStack(stack, currentName, currentIsLink, currentUrl) {
      var home = homeLabel();
      var frag = document.createDocumentFragment();
  
      function addLi(html) {
        var li = document.createElement('li');
        li.innerHTML = html;
        frag.appendChild(li);
      }
  
      addLi('<a href="/" title="Home">' + escapeHtml(home) + '</a>');
  
      stack.forEach(function (e) {
        if (e.type === ENTRY_COLLECTION) {
          addLi('<a href="/collections/' + escapeHtml(e.handle) + '">' + escapeHtml(e.name) + '</a>');
        } else if (e.type === ENTRY_PRODUCT) {
          addLi('<a href="/products/' + escapeHtml(e.handle) + '">' + escapeHtml(e.name) + '</a>');
        }
      });
  
      if (currentIsLink && currentUrl) {
        addLi('<a href="' + escapeHtml(currentUrl) + '">' + escapeHtml(currentName) + '</a>');
      } else {
        addLi(escapeHtml(currentName));
      }
  
      return frag;
    }
  
    function escapeHtml(s) {
      if (s == null) return '';
      var div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    }
  
    function run() {
      var pathname = (window.location.pathname || '').replace(/\/$/, '') || '/';
      if (pathname === '/') {
        setNav([]);
        setTs(Math.floor(Date.now() / 1000));
        return;
      }
  
      var navEl = document.querySelector('.n6br[data-breadcrumb-type]');
      if (!navEl) {
        var collectionMatch = pathname.match(/^\/collections\/([^/]+)/);
        if (collectionMatch) {
          var handleFromUrl = collectionMatch[1];
          var anyNav = document.querySelector('.n6br');
          var titleFromDom = anyNav ? (function () {
            var items = anyNav.querySelectorAll('ol > li');
            var last = items[items.length - 1];
            return last ? last.textContent.trim() : '';
          }()) : '';
          if (handleFromUrl && titleFromDom) {
            var stackFb = getNav();
            if (isExpired()) stackFb = [];
            if (!isBackForward()) {
              var hTrim = handleFromUrl.trim();
              stackFb = removeTrailingProductsFromStack(stackFb);
              stackFb = removeDuplicateCollectionHandles(stackFb, hTrim);
              stackFb.push({
                type: ENTRY_COLLECTION,
                handle: hTrim,
                name: titleFromDom.trim(),
                subcategories: [],
              });
              setNav(finalizeNavStack(stackFb));
              setTs(Math.floor(Date.now() / 1000));
            }
          }
        }
        return;
      }
  
      var type = (navEl.getAttribute('data-breadcrumb-type') || '').trim().toLowerCase();
  
      var stack = getNav();
      if (isExpired()) {
        stack = [];
        setNav(stack);
      }
  
      var skipPush = isBackForward();
      var collections = getCollectionsFromStack(stack);
  
      if (type === 'collection') {
        var collectionHandle = (navEl.getAttribute('data-collection-handle') || '').trim();
        var collectionTitle = (navEl.getAttribute('data-collection-title') || '').trim();
        var collectionMatch = pathname.match(/^\/collections\/([^/]+)/);
        if (!collectionHandle && collectionMatch) collectionHandle = collectionMatch[1];
        var lastLi = navEl.querySelector('ol > li:last-child');
        if (!collectionTitle && lastLi) collectionTitle = lastLi.textContent.trim();
        var parentHandlesRaw = navEl.getAttribute('data-parent-handles');
        var parentHandles = [];
        try {
          if (parentHandlesRaw) parentHandles = JSON.parse(parentHandlesRaw);
        } catch (e) {}

        var subHandles = [];
        try {
          var rawSub = navEl.getAttribute('data-subcategory-handles');
          if (rawSub) subHandles = JSON.parse(rawSub);
        } catch (eSub) {}
        if (!Array.isArray(subHandles)) subHandles = [];

        if (!skipPush && collectionHandle && collectionTitle) {
          stack = removeTrailingProductsFromStack(stack);
          stack = removeDuplicateCollectionHandles(stack, collectionHandle);
          stack = stripCollectionsForNextCollection(stack, collectionHandle, parentHandles);
          collections = getCollectionsFromStack(stack);
        }

        var valid = false;
        if (collections.length >= 1 && collectionHandle) {
          var lastColValid = collections[collections.length - 1];
          valid = lastColAcceptsStep(lastColValid, collectionHandle, parentHandles);
        }

        var ol = navEl.querySelector('ol');
        if (valid && ol && collectionHandle && collectionTitle) {
          var displayCols = collections.length <= MAX_COLLECTIONS ? collections : collections.slice(-MAX_COLLECTIONS);
          var frag = buildOlFromStack(displayCols, collectionTitle, false, null);
          ol.innerHTML = '';
          ol.appendChild(frag);
        }

        if (!skipPush && collectionHandle && collectionTitle) {
          stack.push({
            type: ENTRY_COLLECTION,
            handle: collectionHandle,
            name: collectionTitle,
            subcategories: subHandles,
          });
          setNav(finalizeNavStack(stack));
          setTs(Math.floor(Date.now() / 1000));
        }
        return;
      }
  
      if (type === 'product') {
        var productHandle = (navEl.getAttribute('data-product-handle') || '').trim();
        var productTitle = (navEl.getAttribute('data-product-title') || '').trim();
        var lastLiProduct = navEl.querySelector('ol > li:last-child');
        if (!productTitle && lastLiProduct) productTitle = lastLiProduct.textContent.trim();
  
        var productCollectionHandles = [];
        try {
          var raw = navEl.getAttribute('data-product-collection-handles');
          if (raw) productCollectionHandles = JSON.parse(raw);
        } catch (e) {}

        if (!skipPush) {
          var colsBeforeProduct = getCollectionsFromStack(stack);
          if (colsBeforeProduct.length >= 1) {
            var lastNavCol = colsBeforeProduct[colsBeforeProduct.length - 1];
            var productHasCol =
              productCollectionHandles.length > 0 &&
              productCollectionHandles.indexOf(lastNavCol.handle) !== -1;
            if (!productHasCol) {
              stack = stack.filter(function (e) {
                return e.type !== ENTRY_COLLECTION;
              });
            }
          }
        }
        collections = getCollectionsFromStack(stack);

        var validProduct = false;
        if (collections.length >= 1) {
          var lastColProduct = collections[collections.length - 1];
          if (
            lastColProduct &&
            productCollectionHandles.length > 0 &&
            productCollectionHandles.indexOf(lastColProduct.handle) !== -1
          ) {
            validProduct = true;
          }
        }
  
        var olProduct = navEl.querySelector('ol');
        if (validProduct && olProduct && productTitle) {
          var colsForDisplay =
            collections.length <= MAX_COLLECTIONS ? collections : collections.slice(-MAX_COLLECTIONS);
          var fragProduct = buildOlFromStack(colsForDisplay, productTitle, false, null);
          olProduct.innerHTML = '';
          olProduct.appendChild(fragProduct);
        }
  
        if (!skipPush && productHandle && productTitle) {
          var lastEntry = stack[stack.length - 1];
          if (lastEntry && lastEntry.type === ENTRY_PRODUCT) {
            stack[stack.length - 1] = { type: ENTRY_PRODUCT, handle: productHandle, name: productTitle };
          } else {
            stack.push({ type: ENTRY_PRODUCT, handle: productHandle, name: productTitle });
          }
          setNav(finalizeNavStack(stack));
          setTs(Math.floor(Date.now() / 1000));
        }
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();
  